<script setup lang="ts">
import { ArrowLeft } from 'lucide-vue-next';

interface SharingStep {
  tab: 'preview' | 'templates';
}

defineProps<{
  activeStep: number;
  steps: SharingStep[];
}>();

defineEmits<{
  (e: 'update:activeStep', step: number): void;
}>();
</script>

<template>
  <aside class="share-sidebar-mock dark">
    <!-- Back Pill (only on Desktop) -->
    <div class="sidebar-back-pill dark hide-mobile"><ArrowLeft :size="16" /><span>Back</span></div>
    
    <!-- Modal Title (Desktop Only) -->
    <div class="sidebar-info-group dark hide-mobile">
      <h2>Bet Share</h2>
      <p>Choose image design to share</p>
    </div>

    <!-- Navigation Tabs -->
    <nav class="sidebar-nav-stack dark">
      <button 
        @click="$emit('update:activeStep', 0)" 
        :class="['nav-item-mock dark', { active: steps[activeStep]?.tab === 'preview' }]"
      >
        Preview
      </button>
      <button 
        @click="$emit('update:activeStep', 1)" 
        :class="['nav-item-mock dark', { active: steps[activeStep]?.tab === 'templates' }]"
      >
        Templates
      </button>
    </nav>
  </aside>
</template>

<style scoped>
.share-sidebar-mock { 
  width: 320px; 
  min-width: 320px; 
  background: #09090b; 
  padding: 40px 24px; 
  border-right: 1px solid rgba(255,255,255,0.05); 
  display: flex; 
  flex-direction: column; 
  gap: 40px; 
  box-sizing: border-box; 
}

.sidebar-back-pill { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; background: #18181b; border-radius: 100px; border: 1.5px solid #3f3f46; color: #fff; font-weight: 700; width: fit-content; font-size: 0.85rem; }
.sidebar-info-group h2 { font-size: 2rem; font-weight: 900; margin-bottom: 8px; color: #fff; }
.sidebar-info-group p { color: #71717a; font-size: 0.9rem; }

.sidebar-nav-stack { display: flex; flex-direction: column; gap: 8px; }
.nav-item-mock { 
  padding: 16px 24px; 
  border-radius: 12px; 
  font-weight: 800; 
  color: #71717a; 
  cursor: pointer; 
  transition: all 0.2s ease; 
  width: 100%; 
  box-sizing: border-box; 
  text-align: left; 
  background: transparent;
  border: none;
}
.nav-item-mock.active { 
  background: #e21b0d; 
  color: #fff; 
  box-shadow: 0 4px 12px rgba(226, 27, 13, 0.3); 
  font-weight: 900;
}

@media (max-width: 768px) {
  .share-sidebar-mock { 
    width: 100%; 
    min-width: 100%; 
    height: auto; 
    padding: 16px; 
    gap: 12px; 
    border-right: none; 
    border-bottom: 1px solid rgba(255,255,255,0.05); 
  }
  .sidebar-nav-stack { 
    flex-direction: row; 
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4px;
    width: 100%; 
    background: transparent;
  }
  .nav-item-mock { 
    text-align: center; 
    padding: 12px 8px; 
    border-radius: 12px; 
    font-size: 0.85rem; 
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255,255,255,0.03);
  }
  .nav-item-mock.active {
     background: #e21b0d;
     box-shadow: none;
  }
  .hide-mobile { display: none !important; }
}
</style>
